module.exports = __webpack_public_path__ + "static/media/DSC08646-2.624a00b4.jpeg";